"use client"

import * as React from "react"
import { Bar, BarChart, CartesianGrid, Cell, LabelList, ReferenceLine, XAxis, YAxis } from "recharts"
import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from "src/@/components/ui/card"
import {
    ChartContainer,
    ChartLegend,
    ChartLegendContent,
    ChartTooltip,
    ChartTooltipContent,
} from "src/@/components/ui/chart"
import EmptyContentGhost from "src/components/EmptyContentGhost"

const chartConfig = {
    ganho: {
        label: "ganho",
        color: "#B6A0F7",
    },
    perda: {
        label: "perda",
        color: "#ff5f5f",
    },
}

export function GraficoGanhosPerdas({ chartData }) {

    const newChartData = chartData.map((item) => {
        return {
            usuario: item.usuario,
            total: item.perda + item.ganho
        }
    })

    return (
        <Card className="w-full">
            <CardHeader className="flex items-center gap-2 space-y-0 border-b border-gray-50 py-3 sm:flex-row">
                <div className="grid flex-1 gap-1 text-center sm:text-left">
                    <CardTitle>Ganhos e Perdas de Negócios</CardTitle>
                    <CardDescription>
                        Ganhos e perdas de leads no período por usuário
                    </CardDescription>
                </div>

            </CardHeader>
            <CardContent>
                {
                    chartData?.length === 0 ? (
                        <EmptyContentGhost />
                    ) : (
                        <div className="w-full">
                            <ChartContainer className="h-[400px] w-full" config={chartConfig}>
                                <BarChart data={chartData} width={150}>
                                    <ChartTooltip content={<ChartTooltipContent hideLabel />} />
                                    <XAxis
                                        dataKey="usuario"
                                        tickLine={false}
                                        tickMargin={2}
                                        axisLine={false}

                                    />
                                    <YAxis />
                                    <CartesianGrid vertical={true} />
                                    <ReferenceLine y={0} stroke="#000" />


                                    <Bar dataKey="ganho" barSize={100} stackId={"a"}
                                    >

                                        {chartData.map((item) => (
                                            <Cell
                                                key={item.ganho}
                                                fill="var(--color-ganho)"
                                            />
                                        ))}
                                           <LabelList
                                            dataKey="ganho"
                                            className="fill-background"
                                            stroke="none"
                                            fontSize={12}

                                        />
                                    </Bar>
                                    <Bar dataKey="perda" stackId={"b"}
                                        barSize={100}
                                        radius={[10, 10, 0, 0]}
                                    >

                                        {chartData.map((item) => (
                                            <Cell
                                                key={item.usuario}
                                                fill="var(--color-perda)"
                                            />
                                        ))}
                                        <LabelList
                                            dataKey="perda"
                                            className="fill-background"
                                            stroke="none"
                                            fontSize={12}

                                        />
                                    </Bar>

                                </BarChart>
                            </ChartContainer>
                        </div>
                    )
                }

            </CardContent>
        </Card>
    )
}
